import { render } from "./DiagnosisReport.vue?vue&type=template&id=441746fa&scoped=true"
import script from "./DiagnosisReport.vue?vue&type=script&lang=js"
export * from "./DiagnosisReport.vue?vue&type=script&lang=js"

import "./DiagnosisReport.vue?vue&type=style&index=0&id=441746fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441746fa"],['__file',"src/views/HistoricalData/DiagnosisReport/DiagnosisReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "441746fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('441746fa', __exports__)) {
    api.reload('441746fa', __exports__)
  }
  
  module.hot.accept("./DiagnosisReport.vue?vue&type=template&id=441746fa&scoped=true", () => {
    api.rerender('441746fa', render)
  })

}


export default __exports__